var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},_vm._l((_vm.columnCount),function(index){return _c('div',{key:index,ref:("col" + _vm.rowIndex + index),refInFor:true,staticStyle:{"flex":"1"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }